import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/about-sub-text.png'
import _imports_1 from '../images/shell-blue-bg.png'
import _imports_2 from '../images/about-ripple.png'
import _imports_3 from '../images/about-company-bg.png'
import _imports_4 from '../images/about-timeline.png'
import _imports_5 from '../images/about-timeline-mobile.png'


const _withScopeId = n => (_pushScopeId("data-v-1b139b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-text-wrapper text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " ABOUT ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "sub-text"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_2 + "\" class=\"ripple-bg d-none d-md-block\" data-v-1b139b02><img src=\"" + _imports_2 + "\" class=\"ripple-bg ripple-bg-2 d-none d-md-block\" data-v-1b139b02><div class=\"text-wrapper\" data-v-1b139b02><section data-v-1b139b02><div data-v-1b139b02>가플지우는 깨끗하고 아름다운 우리 바다를 지키기 위한<br class=\"d-md-none\" data-v-1b139b02> 환경 캠페인 플랫폼입니다. </div><div data-v-1b139b02>본 캠페인은 2018년 이마트 성수점을 시작으로 수도권 매장에서<br class=\"d-md-none\" data-v-1b139b02> 운영된 <strong data-v-1b139b02>플라스틱 회수 캠페인</strong>에서 시작되었습니다. </div><div data-v-1b139b02>여러분의 참여로 모인 폐플라스틱은 <br class=\"d-md-none\" data-v-1b139b02>그간 어린이 교통안전 반사판, 접이식 쇼핑카트, 줍깅 집게 등</div><div data-v-1b139b02><strong data-v-1b139b02>새로운 모습으로 업사이클링되어 지역사회로 <br class=\"d-md-none\" data-v-1b139b02>기부</strong>됐습니다. </div></section><br data-v-1b139b02><br data-v-1b139b02><section data-v-1b139b02><div data-v-1b139b02>2021년 봄, 100인의 스타트와 함께 시작했던 줍깅 캠페인은<br class=\"d-md-none\" data-v-1b139b02> 가족, 친구와 함께하는 <strong data-v-1b139b02>일상 속 줍깅 캠페인</strong>으로 확대되며</div><div data-v-1b139b02>버려진 플라스틱 쓰레기들로부터<br class=\"d-md-none\" data-v-1b139b02> 우리의 바다를 지키는 큰 물결로 이어지고 있습니다.</div></section><br data-v-1b139b02><br data-v-1b139b02><section data-v-1b139b02><div data-v-1b139b02>2022년 뜻을 함께하는 많은 파트너사가 동참하며,<br class=\"d-md-none\" data-v-1b139b02> 가플지우는 보다 성장하고 있습니다.</div><div data-v-1b139b02><strong data-v-1b139b02>가까운 산과 들 그리고 강변을 산책할 때,<br class=\"d-md-none\" data-v-1b139b02> 또는 소중한 사람들과 함께 찾은 아름다운 바닷가에서<br class=\"d-md-none\" data-v-1b139b02> 우리의 자연이 아파하지 않도록<br data-v-1b139b02> 여러분도 함께해주세요.</strong></div></section><br data-v-1b139b02><br data-v-1b139b02><section data-v-1b139b02><div data-v-1b139b02>여러분이 함께하는 내일의 가플지우엔<br class=\"d-md-none\" data-v-1b139b02> 또 어떤 새로운 일들이 함께하게 될까요? </div></section><br data-v-1b139b02><br data-v-1b139b02><section class=\"blue\" data-v-1b139b02><div data-v-1b139b02><strong data-v-1b139b02>오늘의 작은 실천이 내일의 지구를 만듭니다.</strong></div><div data-v-1b139b02><strong data-v-1b139b02>가플지우 캠페인이 함께 합니다.</strong></div></section></div>", 3)
const _hoisted_7 = { class: "company-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 가플지우 파트너를 소개합니다 ", -1))
const _hoisted_9 = { class: "companies" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "d-md-none"
}
const _hoisted_13 = {
  key: 1,
  class: "d-none d-md-block"
}
const _hoisted_14 = {
  key: 2,
  class: "d-md-none"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "company-bg d-none d-md-block"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-wrapper\" data-v-1b139b02><div class=\"title\" data-v-1b139b02> 가플지우가 함께한 오늘의 실천 </div><div class=\"timeline-content-wrapper\" data-v-1b139b02><img src=\"" + _imports_2 + "\" class=\"ripple-up d-none d-md-block\" data-v-1b139b02><img src=\"" + _imports_2 + "\" class=\"ripple-down d-none d-md-block\" data-v-1b139b02><img src=\"" + _imports_4 + "\" class=\"timeline-image d-none d-md-block\" data-v-1b139b02><img src=\"" + _imports_5 + "\" class=\"timeline-image d-md-none\" data-v-1b139b02></div></div>", 1)

import { onMounted } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const partners = [
    {
      icon: require('../images/company-1.png'),
      url: 'http://www.waste21.or.kr/',
    },
    {
      icon: require('../images/company-2.png'),
      url: 'https://www.byn.kr/blackyak',
    },
    {
      icon: require('../images/company-3.png'),
      url: 'https://www.brita.kr/',
    },
    {
      icon: require('../images/company-4.png'),
      url: 'https://www.cj.co.kr/kr/index',
    },
    {
      icon: require('../images/company-5.png'),
      url: 'https://company.emart.com/ko/ethic/outline.do',
    },
    {
      icon: require('../images/company-6.png'),
      url: 'https://www.gmarket.co.kr/',
    },
    {
      icon: require('../images/company-7.png'),
      url: 'http://www.iamasurfer.com/default/',
    },
    {
      icon: require('../images/company-8.png'),
      url: 'https://www.koem.or.kr/site/koem/main.do',
    },
    {
      icon: require('../images/company-9.png'),
      url: 'https://pg.co.kr/',
    },
    {
      icon: require('../images/company-10.png'),
      url: 'https://www.posco.co.kr/homepage/docs/kor6/jsp/s91a0000001i.jsp',
    },
    {
      icon: require('../images/company-11.png'),
      url: 'https://www.ssg.com/',
    },
    {
      icon: require('../images/company-12.png'),
      url: 'https://www.terracycle-kr.com/',
    },
    {
      icon: require('../images/company-13.png'),
      url: 'http://uikcompany.com/',
    },
  ];

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
            return _createElementVNode("img", {
              key: item,
              src: _imports_1,
              class: "cover"
            })
          }), 64))
        ])
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(partners, (item, index) => {
          return _createElementVNode("a", {
            key: item.url,
            href: item.url,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: item.icon,
              class: "item"
            }, null, 8, _hoisted_11),
            (index === 3)
              ? (_openBlock(), _createElementBlock("br", _hoisted_12))
              : _createCommentVNode("", true),
            (index === 5)
              ? (_openBlock(), _createElementBlock("br", _hoisted_13))
              : _createCommentVNode("", true),
            (index === 8)
              ? (_openBlock(), _createElementBlock("br", _hoisted_14))
              : _createCommentVNode("", true)
          ], 8, _hoisted_10)
        }), 64))
      ]),
      _hoisted_15
    ]),
    _hoisted_16
  ], 64))
}
}

})